var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1729 1.92591C20.9013 1.92591 18.4321 4.0864 17.4445 7.48146C15.9013 5.07406 14.6667 2.35801 13.9877 0.0123291H10.5309V9.0864C10.5309 10.8765 9.04942 12.358 7.2593 12.358C5.46917 12.358 3.98769 10.8765 3.98769 9.0864V0.0740571H0.654358V9.14813C0.654358 12.9136 3.67905 15.9383 7.38275 15.9383C11.0865 15.9383 14.1111 12.9136 14.1111 9.14813V7.60492C14.7902 8.96294 15.6544 10.4444 16.5803 11.7407L14.4198 21.8025H17.9383L19.4198 14.4568C20.7778 15.321 22.321 15.8148 24.1729 15.8148C27.9383 15.8148 31.0247 12.7284 31.0247 8.77776C31.0247 5.01233 27.9383 1.92591 24.1729 1.92591ZM24.1729 12.358C22.8149 12.358 21.3951 11.7407 20.284 10.8148L20.6544 9.45677V9.39504C20.9013 7.91356 21.7037 5.44443 24.2346 5.44443C26.1482 5.44443 27.6914 6.98764 27.6914 8.90122C27.6297 10.8148 25.963 12.358 24.1729 12.358Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwork);
export default __webpack_public_path__ + "static/media/upwork.ccd66168db507373bfc69541aa3ee021.svg";
export { ForwardRef as ReactComponent };